import { WithStyles, withStyles } from '@mui/styles';

import { ApiFirmView } from './apiFirmView';
import { muiStyles } from './apiFirmViewStyles';

export interface IApiFirmViewProps extends WithStyles<typeof muiStyles> {
    match: any;
}

export default withStyles(muiStyles)(ApiFirmView);